import type { ChatRoom } from 'models';
import type { ReactNode } from 'react';
import { Flex } from 'ui';
import { ChatContentLayout } from '../chat-content-layout';
import { ChatDetailHeaderSkeleton } from '../chat-detail-header-skeleton';
import { ChatDetailMessagesSkeleton } from '../chat-detail-messages-skeleton';
import { ChatroomSidebar, ChatroomSidebarContent } from '../chatroom-sidebar';
import { useChatroomQuery } from '../queries';
import type { ChatroomsSearchParamsOptions } from '../types';

type P = {
  children: (data: { chatroom: ChatRoom }) => ReactNode;
  footer: (chatroomId: string) => ReactNode;
  header: (data: ChatRoom) => ReactNode;
  id: string;
  onChatDeleted: () => Promise<void>;
  onChatRoomClicked: (id: string) => Promise<void>;
  onCreateChatClicked: () => Promise<void>;
  searchParamsOptions: ChatroomsSearchParamsOptions;
};

const ChatDetailLayout = ({
  children,
  footer,
  header,
  id,
  onChatDeleted,
  onChatRoomClicked,
  onCreateChatClicked,
  searchParamsOptions,
}: P) => {
  const { data: chatroom } = useChatroomQuery({ id });

  return (
    <ChatContentLayout
      left={
        <ChatroomSidebar onCreateChatClicked={onCreateChatClicked} searchParamsOptions={searchParamsOptions}>
          {({ filter }) => (
            <ChatroomSidebarContent
              filter={filter}
              onChatDeleted={onChatDeleted}
              onChatRoomClicked={onChatRoomClicked}
              onCreateChatClicked={onCreateChatClicked}
              selectedChatroomId={id}
            />
          )}
        </ChatroomSidebar>
      }
      right={
        <Flex className="chat-detail-layout" vertical>
          {chatroom ? header(chatroom) : <ChatDetailHeaderSkeleton />}
          <Flex className="chat-detail-layout__messages" flex={1} paddingHorizontal="ms" vertical>
            {chatroom ? children({ chatroom }) : <ChatDetailMessagesSkeleton />}
          </Flex>
          {footer(id)}
        </Flex>
      }
    />
  );
};

export default ChatDetailLayout;
